import React, { useEffect, useState } from "react";
import AccordionTable from "../../../../components/accordion/AccordionTable";
import { Box, MenuItem, Tooltip, Typography } from "@mui/material";

import { InputValueProjectForm } from "./domain";
import { useTranslation } from "react-i18next";
import { edpexResponsibleAPI } from "../../../../api/edpex-responsible/edpex-responsible.api";
import { alertActive, alertSuccess } from "../../../../components/alert/swal";
import { ButtonPrimary } from "../../../../components/button/ButtonCustoms";
import ModalCustom from "../../../../components/modal/ModalCustom";
import AutocompleteSelect from "../../../../components/select/autoCompleteSelect";
import { EmployeeApi } from "../../../../api/employee/employee.api";
import UploadAvatar from "../../../../components/upload/UploadAvatar";
import StateComponents from "../../../../components/state-component/StateComponents";
import FilterSelect from "../../../../components/select/filterSelect";
import { EDPEX_PROJECT_RESPONSIBLE_TYPE } from "../enum";

interface IProjectFormProps {
  inputValue: InputValueProjectForm;
  setInputValue: React.Dispatch<React.SetStateAction<InputValueProjectForm>>;
  disabled?: boolean;
}

const ResponsiblePersonForm: React.FC<IProjectFormProps> = ({
  inputValue,
  setInputValue,
  disabled = false,
}) => {
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState<string>("");
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);
  const [imagePath, setImagePath] = useState<string>("");
  const [id_edpex_responsible, set_id_edpex_responsible] = useState<number | null>(null);
  const [employee_detail, set_employee_detail] = useState<any>(null);
  const [inputValueResponsibleForm, setInputValueResponsibleForm] =
    useState<any>({
      id_employee: 0,
      name: "",
      id_department: 0,
      department_name: "",
      employee_no: "",
      position: "",
    });

  const fetchResponsiblePerson = async () => {
    const res = await edpexResponsibleAPI.getEdpexResponsibleList({
      page: 1,
      limit: 10000,
    });
    const data = res.data;
    if (data.status < 300) {
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  };

  useEffect(() => {
    fetchResponsiblePerson();
  }, []);

  const fileHeaders = [
    {
      key: "index",
      label: "ลำดับ",
      width: 1,
      align: "center" as const,
      render: (value: any, rowData: any, rowIndex: number) => (
        <Typography variant="body2">{rowIndex + 1}</Typography>
      ),
    },
    {
      key: "name",
      label: "ชื่อ - นามสกุล",
      width: 4,
      render: (value: string, rowData: any) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Tooltip title={value}>
            <Typography
              variant="body2"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {value}
            </Typography>
          </Tooltip>
        </Box>
      ),
    },
    {
      key: "status",
      label: "สถานะ",
      width: 5,
      align: "center" as const,
      render: (value: string, rowData: any) => (
        <>
          {value === EDPEX_PROJECT_RESPONSIBLE_TYPE.PRIMARY
            ? "ผู้รับผิดชอบหลัก"
            : "ผู้รับผิดชอบร่วม"}
        </>
      ),
    },
  ];

  const handleCloseModal = () => {
    setShowModal("");
    setInputValueResponsibleForm({
      id_employee: 0,
      name: "",
      id_department: 0,
      department_name: "",
      employee_no: "",
      position: "",
    });
    set_id_edpex_responsible(null);
    // set_id_item(null);
  };

  const handleAddItem = () => {

    const newResponsiblePersons = {
      id_employee: inputValueResponsibleForm.id_employee,
      first_name: inputValueResponsibleForm.first_name,
      name: inputValueResponsibleForm.name,
      department_name: inputValueResponsibleForm.department_name,
      employee_no: inputValueResponsibleForm.employee_no,
      position: inputValueResponsibleForm.position,
      status: inputValueResponsibleForm.status,
    };

    setInputValue((prev) => ({
      ...prev,
      responsiblePersons: [...prev.responsiblePersons, newResponsiblePersons],
    }));

    alertSuccess("ผู้รับผิดชอบ เรียบร้อย", undefined, undefined, () => {
      setShowModal("");
    });

    // alertError("ผู้รับผิดชอบ ไม่สำเร็จ");
  };

  const getDataEmployeeById = async (id: number) => {
    const res = await EmployeeApi.getOne(id);
    const data = res.data;
    if (data.status < 300) {
      set_employee_detail(res.data?.data || null)
      setImagePath(data.data?.employee_image[0]?.file_path ?? "");
    } else {
      setImagePath("");
    }
  };

  // const handleEditItem = (
  //   id: number,
  //   updatedData: Partial<{ name: string; value: string }>
  // ) => {
  //   setInputValue((prev) => ({
  //     ...prev,
  //     responsiblePersons: prev.responsiblePersons.map((item) =>
  //       item.id === id ? { ...item, ...updatedData } : item
  //     ),
  //   }));
  //   setShowModal("");
  // };

  const handleDeleteItem = (_: any, i: number) => {
    alertActive(
      "ลบผู้รับผิดชอบ",
      "ท่านต้องการลบผู้รับผิดชอบ ใช่หรือไม่",
      undefined,
      undefined,
      async () => {
        setInputValue((prev) => ({
          ...prev,
          responsiblePersons: prev.responsiblePersons.filter((_: any, index: number) => index !== i),
        }));
        setShowModal("");
      }
    );
  };

  useEffect(() => {
    if (id_edpex_responsible) {
      const person_detail = dataEmployee?.find((x) => x?.id_edpex_responsible == id_edpex_responsible);
      getDataEmployeeById(person_detail?.id_employee);
      setInputValueResponsibleForm((prev: any) => ({
        ...prev,
        id_employee: person_detail?.id_edpex_responsible,
        name: person_detail?.name,
        id_department: person_detail?.id_department,
        department_name: person_detail?.department,
        employee_no: person_detail?.employee_no,
        position: person_detail?.position_name,
      }));
    }
  }, [id_edpex_responsible])

  const is_view = (showModal === 'VIEW');
  return (
    <>
      {showModal && (
        <ModalCustom
          open
          title={
            showModal === "ADD"
              ? t("เพิ่มผู้รับผิดชอบ")
              : showModal === "VIEW"
                ? t("ข้อมูลผู้รับผิดชอบ")
                : ""
          }
          subTitle={t("PLEASE_SELECT_LIST")}
          onClose={handleCloseModal}
          component={
            <div className="w-full">
              {!is_view && (
                <AutocompleteSelect
                  required
                  heading={"เพิ่มผู้รับผิดชอบ"}
                  freeSolo
                  labelId={"-"}
                  options={dataEmployee ?? []}
                  getOptionLabel={(option: any) => `${option?.name}` || ""}
                  renderOption={(props, option) => (
                    <li {...props}>{`${option?.name}`}</li>
                  )}
                  onChange={(_, value: any) => {
                    if (value) {
                      getDataEmployeeById(value.id_employee);
                      setInputValueResponsibleForm({
                        id_employee: value.id_edpex_responsible,
                        // joedev ใช้ id ผิด table  แก้ไขเฉพาะหน้า ต้องใช้ id_edpex_responsible
                        // id_employee: value.id_employee,
                        name: value.name,
                        id_department: value.id_department,
                        department_name: value.department,
                        employee_no: value.employee_no,
                        position: value.position_name,
                      });
                    }
                  }}
                />
              )}
              <br />

              {inputValueResponsibleForm.id_employee ? (
                <>
                  <div className="w-full flex justify-center items-center">
                    <UploadAvatar
                      filePath={imagePath}
                      onDrop={() => { }}
                      file={imagePath}
                      noClick={true}
                      hiddenDeleteButton={true}
                      onDelete={() => { }}
                    />
                  </div>

                  <br />

                  <FilterSelect
                    value={inputValueResponsibleForm.status ?? ""}
                    labelId="สถานะ-id"
                    selectId="สถานะ-select-id"
                    disabled={is_view}
                    heading="สถานะ"
                    required
                    options={[
                      {
                        value: EDPEX_PROJECT_RESPONSIBLE_TYPE.PRIMARY,
                        name: "ผู้รับผิดชอบหลัก",
                      },
                      {
                        value: EDPEX_PROJECT_RESPONSIBLE_TYPE.SECONDARY,
                        name: "ผู้รับผิดชอบร่วม",
                      },
                    ].map((item: any, index: number) => (
                      <MenuItem value={item?.value} key={index + 1}>
                        {item?.name}
                      </MenuItem>
                    ))}
                    onchange={(e: any) => {
                      setInputValueResponsibleForm({
                        ...inputValueResponsibleForm,
                        status: e.target.value,
                      });
                    }}
                  />

                  <StateComponents
                    sxContainer={{ mt: 2 }}
                    otherProps={{ spacing: 2 }}
                    typeProps={[
                      {
                        seq: 1,
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          disabled: true,
                          value: inputValueResponsibleForm.name,
                          heading: t("ชื่อ-นามสกุล"),
                          placeholder: t("ชื่อ-นามสกุล"),
                          onChange: (e) => { },
                        },
                        type: "TEXT_FIELD",
                      },
                      {
                        seq: 2,
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          disabled: true,
                          value: inputValueResponsibleForm.employee_no,
                          heading: t("เลขประจำตัวเจ้าหน้าที่"),
                          placeholder: t("เลขประจำตัวเจ้าหน้าที่"),
                          onChange: (e) => { },
                        },
                        type: "TEXT_FIELD",
                      },
                      {
                        seq: 3,
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          disabled: true,
                          value: employee_detail?.work_history?.position_name || "",
                          heading: t("ตำแหน่งงาน"),
                          placeholder: t("ตำแหน่งงาน"),
                          onChange: (e) => { },
                        },
                        type: "TEXT_FIELD",
                      },
                      {
                        seq: 3,
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          disabled: true,
                          value: employee_detail?.department?.department_name_th || "",
                          heading: t("หน่วยงาน"),
                          placeholder: t("หน่วยงาน"),
                          onChange: (e) => { },
                        },
                        type: "TEXT_FIELD",
                      },
                    ]}
                  />
                </>
              ) : null}

              <div className="mt-6 w-full flex justify-center gap-4 items-center">
                <span>
                  <ButtonPrimary
                    mode="del"
                    buttonName={t("BUTTON.CANCEL")}
                    onClick={handleCloseModal}
                  />
                </span>
                {showModal !== "VIEW" && (
                  <span>
                    <ButtonPrimary
                      mode="done"
                      buttonName={t("BUTTON.CONFIRM")}
                      disabled={!inputValueResponsibleForm.id_employee || !inputValueResponsibleForm.status}
                      onClick={handleAddItem}
                    />
                  </span>
                )}
              </div>
            </div>
          }
        />
      )}

      <AccordionTable
        defaultExpanded
        required
        titleName="ผู้รับผิดชอบ"
        headers={fileHeaders}
        data={inputValue.responsiblePersons}
        enableButtonLeft
        onClickButtonLeft={() => {
          setShowModal("ADD");
        }}
        onViewClick={(rowData) => {
          // console.log(rowData, 'rowData');
          set_id_edpex_responsible(rowData?.id_employee);
          setInputValueResponsibleForm((prev: any) => ({ ...prev, status: rowData?.status }))
          setShowModal("VIEW");
        }}
        onDeleteClick={handleDeleteItem}
        isView={disabled}
      />
    </>
  );
};

export default ResponsiblePersonForm;
